"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _Order = _interopRequireDefault(require("../model/Order"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Orders service.
* @module api/OrdersApi
* @version 3.0
*/
var OrdersApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new OrdersApi. 
  * @alias module:api/OrdersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OrdersApi(apiClient) {
    _classCallCheck(this, OrdersApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Get an Order.
   * Get a specific Order for the given Customer and Order IDs.<br>Use this API to check on the status of the Order, as it moves from ‘payment-processed’ to ‘successful’ or ‘failed’.<br>An order in a ‘failed’ state will not return an API error, and checking on the Order status is necessary.<br>
   * @param {Number} customerId Customer ID
   * @param {Number} orderId Order ID
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Order} and HTTP response
   */
  return _createClass(OrdersApi, [{
    key: "getOrderWithHttpInfo",
    value: function getOrderWithHttpInfo(customerId, orderId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getOrder");
      }
      // verify the required parameter 'orderId' is set
      if (orderId === undefined || orderId === null) {
        throw new Error("Missing the required parameter 'orderId' when calling getOrder");
      }
      var pathParams = {
        'customerId': customerId,
        'orderId': orderId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Order["default"];
      return this.apiClient.callApi('/customers/{customerId}/orders/{orderId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get an Order.
     * Get a specific Order for the given Customer and Order IDs.<br>Use this API to check on the status of the Order, as it moves from ‘payment-processed’ to ‘successful’ or ‘failed’.<br>An order in a ‘failed’ state will not return an API error, and checking on the Order status is necessary.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} orderId Order ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Order}
     */
  }, {
    key: "getOrder",
    value: function getOrder(customerId, orderId) {
      return this.getOrderWithHttpInfo(customerId, orderId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a list of Orders.
     * Get a list of Orders for the Customer.<br>Pass in the basketRefId parameter from the Confirmed Basket to get the specific Order which was created from the Confirmed Basket.<br>Use this API to get the OrderId needed to check on the specific Order being transacted through the SR-SSB.<br>
     * @param {Number} customerId Customer ID
     * @param {Object} opts Optional parameters
     * @param {String} [basketRefId] Basket Ref ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Order>} and HTTP response
     */
  }, {
    key: "getOrdersWithHttpInfo",
    value: function getOrdersWithHttpInfo(customerId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getOrders");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {
        'basketRefId': opts['basketRefId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Order["default"]];
      return this.apiClient.callApi('/customers/{customerId}/orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a list of Orders.
     * Get a list of Orders for the Customer.<br>Pass in the basketRefId parameter from the Confirmed Basket to get the specific Order which was created from the Confirmed Basket.<br>Use this API to get the OrderId needed to check on the specific Order being transacted through the SR-SSB.<br>
     * @param {Number} customerId Customer ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.basketRefId Basket Ref ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Order>}
     */
  }, {
    key: "getOrders",
    value: function getOrders(customerId, opts) {
      return this.getOrdersWithHttpInfo(customerId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();